import { ToastMessage } from "rimble-ui";
import React from 'react';
export default {
  ToastMessage,
  React
};